<h3 mat-dialog-title>FILTRAR CLIENTES</h3>
<div mat-dialog-content style="width: 100%">
    
    <mat-form-field appearance="outline" style="width: 48%; margin-right: 10px;">
        <mat-label>Conta</mat-label>
        <input 
            matInput 
            placeholder="Conta Cliente" 
            [formControl]="numero_xp" 
            name="numero_xp" 
            maxlength="20"
        >
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%" style="width: 48%">
        <mat-label>Nome</mat-label>
        <input matInput placeholder="Nome" [formControl]="nome" name="nome" maxlength="255">
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 48%; margin-right: 10px;">
        <mat-label>Tipo de Cliente</mat-label>
        <mat-select 
            matNativeControl 
            [(value)]="model.tipo_cliente"
            name="tipo_cliente"
            [formControl]="tipo_cliente" 
            (change)="changeTipoCliente()">
            
            <mat-option value="">TODOS</mat-option>
            <mat-option value="PF">Pessoa Física</mat-option>
            <mat-option value="PJ">Pessoa Jurídica</mat-option>
        </mat-select>
    </mat-form-field>
    
    <mat-form-field appearance="outline" style="width: 100%" *ngIf="isCnpj" style="width: 48%">
        <mat-label>CNPJ</mat-label>
        <input matInput placeholder="CNPJ" [formControl]="documento" name="documento" maxlength="255" mask="00.000.000/0000-00">										
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%" *ngIf="isCpf" style="width: 48%; margin-right: 10px;" >
        <mat-label>CPF</mat-label>
        <input matInput placeholder="CPF" [formControl]="documento" name="documento" maxlength="255" mask="000.000.000-00">
    </mat-form-field>
    
    <mat-form-field appearance="outline" style="width: 100%" *ngIf="isCnpj">
        <mat-label>Razão Social</mat-label>
        <input matInput placeholder="Razão Social" [formControl]="razao_social" name="razao_social" maxlength="255">
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%" *ngIf='habilitaEscritorios || usuario.role_id == 2 || usuario.role_id == 7 || usuario.role_id == 4'>
        <mat-label>Escritório</mat-label>
        <mat-select 
            placeholder="Escritório" 
            [(value)]="model.escritorio_id"
            [formControl]="escritorio_id" 
            (selectionChange)="selectEscritorio($event)">
            <mat-option value="">TODOS</mat-option>
            <mat-option *ngFor="let escritorio of listEscritorios"
                [value]="escritorio.id">{{escritorio.nome_fantasia}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerEscritorio"></mat-spinner> 
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%" *ngIf='usuario.role_id != 5'>
        <mat-label>Assessor</mat-label>
        <mat-select placeholder="Assessor"
                    [(value)]="model.assessor_id" 
                    [formControl]="assessor_id"
                    required name="assessor_id" >
            <mat-option value="">Selecione...</mat-option>
            <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{assessor.name}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>        
    </mat-form-field>

    <div fxLayout="row" fxLayoutAlign="space-between">
        <mat-form-field appearance="outline" fxFlex="49">
            <mat-label>Profissão</mat-label>
            <mat-select 
                placeholder="Profissão"
                [(value)]="model.profissao_id" 
                [formControl]="profissao_id"
                name="profissao_id" 
            >
                <mat-option value="">Selecione...</mat-option>
                <mat-option *ngFor="let profissao of listProfissao" [value]="profissao.id">{{profissao.nome}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerProfissao"></mat-spinner>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="49">
            <mat-label>Classficação</mat-label>
            <mat-select 
                placeholder="Classficação"
                [(value)]="model.primeiro_contato_id" 
                [formControl]="primeiro_contato_id"
                name="primeiro_contato_id" 
            >
                <mat-option value="">Selecione...</mat-option>
                <mat-option 
                    *ngFor="let classificacao of listClassificacao" 
                    [value]="classificacao.id"
                >
                    {{classificacao.nome}}
                </mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerClassificacao"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between">
        <mat-form-field appearance="outline" fxFlex="49">
            <mat-label>Cliente Home Broker</mat-label>
            <mat-select 
                matNativeControl 
                [(ngModel)]="model.homebroker"  
                name="homebroker"
                [formControl]="homebroker">
                <mat-option value="">Todos</mat-option>
                <mat-option value="true">Sim</mat-option>
                <mat-option value="false">Não</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="49">
            <mat-label>Cliente Prospect</mat-label>
            <mat-select 
                matNativeControl 
                [(ngModel)]="model.prospect"  
                name="prospect"
                [formControl]="prospect">
                <mat-option value="">Todos</mat-option>
                <mat-option value="true">Sim</mat-option>
                <mat-option value="false">Não</mat-option>
            </mat-select>
        </mat-form-field>  
        
        <mat-form-field appearance="outline" fxFlex="49">
            <mat-label>Conta ativa</mat-label>    
            <mat-select 
                matNativeControl
                [(ngModel)]="model.inativo"
                name="inativo"
                [formControl]="inativo">
                <mat-option value="">Todas</mat-option>
                <mat-option [value]="false">Sim</mat-option>
                <mat-option [value]="true">Não</mat-option>
            </mat-select>
        </mat-form-field>

    </div>    

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="filtrar()" tabindex="-1">Filtrar</button>
</div>